module.exports = "\n<div>\n    <div class=\"starter-template\">\n        <simple-notifications></simple-notifications>\n        <ng4-loading-spinner> </ng4-loading-spinner>\n        <app-header> </app-header>\n        <router-outlet></router-outlet>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main